import { Task, TaskProvider } from '../types';

export class PartnerTasksAdapter {
  static adaptTasks(data: any): Task[] {
    console.log('🔄 PartnerTasksAdapter.adaptTasks - start', data);

    try {
      if (!data || !data.tasks || !Array.isArray(data.tasks)) {
        console.warn('⚠️ Invalid data structure in PartnerTasksAdapter', data);
        return [];
      }

      return data.tasks.map(PartnerTasksAdapter.adaptTask);
    } catch (error) {
      console.error('❌ PartnerTasksAdapter.adaptTasks - error', error);
      throw error;
    }
  }

  private static adaptTask(task: any): Task {
    return {
      id: task.id,
      title: task.name,
      icon: task.icon,
      type: 'partners',
      rewards: {
        dc: task.rewards?.find((r: any) => r.type === 'DC')?.amount || 0,
        tickets: task.rewards?.find((r: any) => r.type === 'tickets')?.amount || 0
      },
      status: task.status,
      is_subscribed: task.partner?.is_subscribed,
      link: task.partner?.link,
      buttonText: 'Выполнить',
      provider: 'PARTNERS' as TaskProvider,
      progress: {
        current: 0,
        total: 1
      }
    };
  }
} 